// utils/wordEditDistance.ts  (or directly in your component file)

 
  export function minWordEditDistance(text1, text2){
    const words1 = text1.trim().split(/\s+/); // better split (handles multiple spaces)
    const words2 = text2.trim().split(/\s+/);
  
    const m = words1.length;
    const n = words2.length;
  
    // dp[i][j] = min operations to convert first i words of text1 → first j words of text2
    const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));
  
    // Base cases
    for (let i = 0; i <= m; i++) dp[i][0] = i;
    for (let j = 0; j <= n; j++) dp[0][j] = j;
  
    // Fill DP table
    for (let i = 1; i <= m; i++) {
      for (let j = 1; j <= n; j++) {
        if (words1[i - 1] === words2[j - 1]) {
          dp[i][j] = dp[i - 1][j - 1];
        } else {
          dp[i][j] = 1 + Math.min(
            dp[i - 1][j],     // delete
            dp[i][j - 1],     // insert
            dp[i - 1][j - 1]  // replace
          );
        }
      }
    }
  
    // Backtrack to find operations
    const edits = [];
    let i = m;
    let j = n;
  
    while (i > 0 || j > 0) {
      if (i > 0 && j > 0 && words1[i - 1] === words2[j - 1]) {
        i--;
        j--;
      } else if (j > 0 && (i === 0 || dp[i][j] === dp[i][j - 1] + 1)) {
        edits.push({ type: 'insert', word: words2[j - 1] });
        j--;
      } else if (i > 0 && (j === 0 || dp[i][j] === dp[i - 1][j] + 1)) {
        edits.push({ type: 'delete', word: words1[i - 1] });
        i--;
      } else if (i > 0 && j > 0) {
        edits.push({ type: 'replace', word1: words1[i - 1], word2: words2[j - 1] });
        i--;
        j--;
      }
    }
  
    edits.reverse();
  
    // Count summary
    const summary = {
      inserted: edits.filter(e => e.type === 'insert').length,
      deleted: edits.filter(e => e.type === 'delete').length,
      replaced: edits.filter(e => e.type === 'replace').length,
      totalChanged: edits.length,
    };
  
    return {
      distance: dp[m][n],
      edits,
      summary,
    };
  }